export default (theme) => ({
  root: {
    textTransform: 'none',
    fontWeight: 500,
    padding: '6px 12px',
    borderWidth: 1,
    borderStyle: 'solid',
    boxShadow: 'none',
    transition: 'background-color 120ms ease, color 120ms ease, border-color 120ms ease',
    '&:hover': { boxShadow: 'none' },
    '&:focus': { boxShadow: 'none' },
    '&.Mui-disabled': {
      opacity: 0.5,
    },
  },
  sizeSmall: {
    padding: '2px 12px',
    fontSize: 14,
    lineHeight: 1.6,
  },
  // Affirmative action — outlined primary, fills on hover/focus and
  // flips text to white. Border collapses into the background fill so
  // the button doesn't gain visual weight on hover.
  colorPrimary: {
    color: theme.palette.primary.main,
    borderColor: theme.palette.primary.main,
    backgroundColor: 'transparent',
    '&:hover': {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.textColor.white,
      borderColor: theme.palette.primary.main,
    },
    '&:focus': {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.textColor.white,
      borderColor: theme.palette.primary.main,
    },
  },
  // Passive companion — uses secondary text color so the pair reads
  // as "default action vs. dismiss" rather than two equal-weight CTAs.
  colorSecondary: {
    color: theme.palette.textColor.secondary,
    borderColor: theme.palette.textColor.secondary,
    backgroundColor: 'transparent',
    '&:hover': {
      backgroundColor: theme.palette.textColor.secondary,
      color: theme.palette.textColor.white,
      borderColor: theme.palette.textColor.secondary,
    },
    '&:focus': {
      backgroundColor: theme.palette.textColor.secondary,
      color: theme.palette.textColor.white,
      borderColor: theme.palette.textColor.secondary,
    },
  },
});
